var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-amap-ctn"},[_c('div',{ref:"aMap",staticClass:"v-amap"}),(_vm.AMap && _vm.aMap)?[_vm._t("default",null,{"AMap":_vm.AMap,"aMap":_vm.aMap})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }